import * as type from './constant';

export const getFinancePerson = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getFinancePersonSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getFinancePersonError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addFinancePerson = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addFinancePersonSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateFinancePerson = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateFinancePersonSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteFinancePerson = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteFinancePersonSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationFinancePersonError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
